import { Cookie } from "@modules/util/Cookie"
import { updateUrl } from "@modules/util/url"

const navigationLayerCookie = new Cookie("navigationCookie", {
    path: "/",
    domain: SiteInfo.cookieDomain,
})

const orderedAdvertsCookie = new Cookie("orderedAdvertsConfig", {
    path: "/",
    domain: SiteInfo.cookieDomain,
})

const muenchenHighlightSwiper = document.getElementById("muenchen-highlight-container")
if (muenchenHighlightSwiper) {
    const wiesnElements: NodeListOf<HTMLAnchorElement> =
        muenchenHighlightSwiper.querySelectorAll("a[data-next-previous-id]")

    for (const element of wiesnElements) {
        element.addEventListener("click", (event: MouseEvent) => {
            setOrderedPreviousNextCookie(event)
        })
    }
}

function setOrderedPreviousNextCookie(event: MouseEvent) {
    const composedPath = event.composedPath().filter((element): element is EventTarget => element != null)
    const cardWithNextPreviousId = getNextPreviousCard(composedPath)

    if (!cardWithNextPreviousId) {
        return null
    }

    let pageElement = cardWithNextPreviousId.previousElementSibling
    while (!pageElement?.hasAttribute("data-page") && pageElement !== null) {
        pageElement = pageElement?.previousElementSibling || null
    }
    const page = pageElement?.getAttribute("data-page")
    if (page) {
        const newUrl = new URL(window.location.href)
        newUrl.searchParams.set("page", page)
        updateUrl(newUrl.href)
    }

    const previousNextId = cardWithNextPreviousId.getAttribute("data-next-previous-id")

    // Yii compatible variant. Remove when switching to new EZA's on live
    orderedAdvertsCookie.expires = Cookie.getExpireDate(3600 * 24)
    orderedAdvertsCookie.value = {
        currentOrderedId: previousNextId,
        currentOrderedReferrer: "contentcatalog-anzeigenmarkt",
        currentBacklinkAdvertUrl: window.location.href,
        currentSearchHash: SiteInfo.currentSearchHash,
    }

    navigationLayerCookie.expires = Cookie.getExpireDate(3600 * 24)
    navigationLayerCookie.value = {
        advertId: SiteInfo.advertId,
        advertName:
            siteConfig.trackingParameters.name === "{__REPLACE_TRACKING_ADVERT_NAME__}"
                ? null
                : encodeURIComponent(siteConfig.trackingParameters.name),
        clickedAdvertId: previousNextId,
        backlinkUrl: window.location.href,
        searchHash: SiteInfo.currentSearchHash,
        referrerTitle: SiteInfo.controller,
    }
}

document.addEventListener("mousedown", (event) => {
    return setOrderedPreviousNextCookie(event)
})

document.addEventListener("click", (event) => {
    const composedPath = event.composedPath().filter((element): element is EventTarget => element != null)
    const cardWithNextPreviousId = getNextPreviousCard(composedPath)

    if (!cardWithNextPreviousId) {
        return null
    }

    if (SiteInfo.controller === "anzeigenmarkt") {
        for (const key of Object.keys(localStorage)) {
            if (/^scrollToPreviousNextId/.test(key)) {
                localStorage.removeItem(key)
            }
        }
    }

    localStorage.setItem(
        `scrollToPreviousNextId_${SiteInfo.controller}_${SiteInfo.advertId}`,
        cardWithNextPreviousId.getAttribute("data-next-previous-id") || "",
    )
})

export function getNextPreviousCard(elements: EventTarget[]) {
    let cardWithNextPreviousId = null
    for (const element of elements) {
        if (element instanceof HTMLElement && element.hasAttribute("data-next-previous-id")) {
            cardWithNextPreviousId = element
            break
        }
    }

    if (!cardWithNextPreviousId) {
        return null
    }
    return cardWithNextPreviousId
}

export function scrollToPreviousNextCard(prevNextId: string, block: "center" | "end" | "start" = "center") {
    window.history.scrollRestoration = "manual"
    setTimeout(() => {
        const target = document.querySelector(`[data-next-previous-id="${prevNextId}"]`)
        if (!target) {
            tryRestoreLastScrollPositionAzm()
            return
        }
        target?.scrollIntoView({
            behavior: "instant",
            block,
        })
    }, 250)
}

export function tryRestoreLastScrollPositionAzm() {
    const scrollingLastPrevNextCard = localStorage.getItem("scrollingLastPrevNextCard")
    if (scrollingLastPrevNextCard) {
        localStorage.removeItem("scrollingLastPrevNextCard")
        const parsed = JSON.parse(scrollingLastPrevNextCard)
        scrollToPreviousNextCard(parsed.prevNextId, parsed.block)
        return true
    }
    return false
}
